import {
  type ITimeGranularity,
  type ITimeGranularityV2,
} from "@north-beam/nb-common";

import {
  MAX_LOOKBACK_DAYS_COMPARE_DAILY,
  MAX_LOOKBACK_DAYS_COMPARE_HOURLY,
  MAX_LOOKBACK_DAYS_DAILY,
  MAX_LOOKBACK_DAYS_HOURLY,
} from "../constants";

export const maxLookbackDaysForTimeGranularity = (
  timeGranularity: ITimeGranularity | ITimeGranularityV2,
) =>
  timeGranularity === "hourly"
    ? ([MAX_LOOKBACK_DAYS_HOURLY, MAX_LOOKBACK_DAYS_COMPARE_HOURLY] as const)
    : ([MAX_LOOKBACK_DAYS_DAILY, MAX_LOOKBACK_DAYS_COMPARE_DAILY] as const);
